<script lang="ts">
  import Menu from '../Menu/Menu.svelte';

  interface Props {
    list?: CommonList[];
    hasOverflow?: boolean;
    onclick?: (detail: any) => void;
  }

  let { list = [], hasOverflow = false, onclick }: Props = $props();
</script>

{#if Array.isArray(list) && list.length !== 0}
  <div class="option-cell">
    <Menu {hasOverflow} {list} {onclick} />
  </div>
{/if}

<style>
  /* your styles go here */
</style>
